 $(document).ready(function(){
   

  
 $(document).on("click", '#custom_feature_prodd .faq_accordion .faq_warp', function (e) {
       e.stopImmediatePropagation();
  e.preventDefault();

   $(this).find('.answerrr').slideToggle();
      $(this).find('.question_wrap svg').toggleClass('rotate__180'); 

    
    });


     
 $(document).on("click", '.product .faq_accordion .faq_warp', function (e) {
       e.stopImmediatePropagation();
  e.preventDefault();

   $(this).find('.answerrr').slideToggle();
      $(this).find('.question_wrap svg').toggleClass('rotate__180'); 

    
    });
})  
document.addEventListener('DOMContentLoaded', function () {


    // Initialize Swipers
    var thumbSwiper = new Swiper('.custom__featured_product .custom_slider_main .thumbSwiper', {
      spaceBetween: 25,
      slidesPerView: 5,
      watchSlidesProgress: true,
      loop: false,
      navigation: {
        nextEl: '.custom_slider_main .thumbSwiper .swiper-button-next',
        prevEl: '.custom_slider_main .thumbSwiper .swiper-button-prev',
      },
      breakpoints: {
        769: { direction: 'horizontal' },
        481: { direction: 'horizontal' },
        0: { slidesPerView: 4, spaceBetween: 12 },
      },
    });

    var featuredSwiper = new Swiper('.custom__featured_product .custom_slider_main .featuredSwiper', {
      spaceBetween: 1,
      slidesPerView: 1,
      navigation: {
        nextEl: '.custom_slider_main .featuredSwiper .swiper-button-next',
        prevEl: '.custom_slider_main .featuredSwiper .swiper-button-prev',
      },
      thumbs: {
        swiper: thumbSwiper,
      },
    });

    // Desktop Thumbnails Click
    var desktopThumbnails = document.querySelectorAll('.custom_slider_main .desktop_thumbnails_image .images_thumnal');

    desktopThumbnails.forEach(function (thumbnail, index) {
      thumbnail.addEventListener('click', function () {
     
        // Slide main Swiper to clicked index
        featuredSwiper.slideTo(index);

        // Remove active class from all
        desktopThumbnails.forEach(function (el) {
          el.classList.remove('active');
        });

        // Add active class to clicked thumbnail
        thumbnail.classList.add('active');
      });
    });

    // Optional: Set first thumbnail as active initially
    if (desktopThumbnails.length > 0) {
      desktopThumbnails[0].classList.add('active');
    }



    $(".footer__follow-on-shop .custom_follow").click(function(){
 
          $(".footer__follow-on-shop .orignial_follow").trigger("click");
          alert("click")
    })
  });

$(document).ready(function(){
  $(".custom__featured_product .product-form__buttons").click(function(e){
    $("cart-drawer").addClass("active");
    
    fetch("/?sections=cart-drawer")
          .then((res) => res.json())
          .then((data) => {
            const sectionHTML = data["cart-drawer"];
            const $temp = $("<div>").html(sectionHTML);
            const newCartItems = $temp.find(".drawer__cart-items-wrapper").html();
            const newSubtotal = $temp.find(".totals__subtotal-value").html();

            // Update cart content in your drawer
            $(".drawer__cart-items-wrapper").html(newCartItems);
            $(".totals__subtotal-value").html(newSubtotal);
          })
          .catch((err) => {
            console.error("Failed to update cart drawer:", err);
          });
  })
changingTAg();
$(window).resize(changingTAg);
  function changingTAg(){
  if (window.innerWidth <= 768){
  $(".custom_hp_banner .wrapper .content_container.desktop h1.heading").replaceWith(function () {
        return $("<h2>").html($(this).html());
      });
       $(".custom_hp_banner .wrapper .category_wraper.theslider_mob h2.heading").replaceWith(function () {
        return $("<h1>").html($(this).html());
      });
    }else{

  $(".custom_hp_banner .wrapper .category_wraper.theslider_mob h1.heading").replaceWith(function () {
        return $("<h2>").html($(this).html());
      });
       $(".custom_hp_banner .wrapper .content_container.desktop h2.heading").replaceWith(function () {
        return $("<h1>").html($(this).html());
      });
    }
  }

})




// PDP JS
document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.custom_slider_main').forEach(function(wrap){

    const thumbsEl = wrap.querySelector('.thumbSwiper');
    const mainEl   = wrap.querySelector('.featuredSwiper');

    if (!thumbsEl || !mainEl) return;
    if (typeof Swiper === "undefined") return;

    // Thumbs
    const thumbSwiper = new Swiper(thumbsEl, {
      spaceBetween: 12,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });

    // Main
    new Swiper(mainEl, {
      spaceBetween: 1,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        nextEl: wrap.querySelector('.custom_featured_image .swiper-button-next'),
        prevEl: wrap.querySelector('.custom_featured_image .swiper-button-prev'),
      },
      thumbs: { swiper: thumbSwiper },
    });

  });

});
